import React from 'react';
// components
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';
import { styled } from 'styles/utils';

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: '#fff',
}));

export const PageLoader = (): JSX.Element => {
  return (
    <StyledBackdrop open={ true }>
      <CircularProgress size={ 60 } color="primary"/>
    </StyledBackdrop>
  );
};
